import React from "react";
import ProjectDetailCard from "../ProjectDetailCard";

import household from "../../../Assets/Projects/website/Household1.png";
import household2 from "../../../Assets/Projects/website/Household2.png";
import household3 from "../../../Assets/Projects/website/Household3.png";
import household4 from "../../../Assets/Projects/website/Household4.png";
import household5 from "../../../Assets/Projects/website/Household5.png";
import household6 from "../../../Assets/Projects/website/Household6.png";
import household7 from "../../../Assets/Projects/website/Household7.png";

function Household() {
  return (
    <ProjectDetailCard
      title="Household Management System"
      image={household}

      screenshots={[
        household2,
        household3,
        household4,
      ]}

      description="
      Household Management System is a web-based application developed during my MSIB internship at PT Telkomsel. The system was designed to simplify household sales data management by integrating interactive dashboards, automated data processing, and centralized reporting into a single platform. It enables users to manage large volumes of household sales data efficiently while providing accurate insights for data-driven decision making. Through optimized database performance and an intuitive user interface, the application significantly improved productivity and reduced manual processing efforts.
      "

      technologies={[
        "PHP",
        "CodeIgniter 4",
        "JavaScript",
        "PostgreSQL",
        "Tailwind CSS",
        "HTML5",
        "CSS3",
        "Git",
      ]}

      github="https://github.com/Rezaananda28"
      demo=""
    >

      {/* Gallery */}

      <div className="project-section-card mt-4">

        <h3 className="purple">
          Project Gallery
        </h3>

        <div className="gallery-grid">

          <img src={household5} alt="gallery1" />

          <img src={household6} alt="gallery2" />

          <img src={household7} alt="gallery3" />

        </div>

      </div>

    </ProjectDetailCard>
  );
}

export default Household;